import service from "./service"

const uploadAdditionalDocument = async (input) => {
    return await service(input)
}

export default uploadAdditionalDocument
